export const loading = (state) => state.loading

export const homePageData = (state) => state.homePageData

export const getProductsByCollectionId = (state) => (collectionId) =>
  state.products[collectionId] || false

export const hideComponent = (state) => state.hideComponent
